import React from 'react';
import {PrimaryButton as StyledPrimaryButton} from "../styled-components/buttons";
import styled from "styled-components";
import {ClipLoader} from "react-spinners";

interface PrimaryButtonProps {
    text: string,
    onClick: any,
    disabled?: boolean
    loading?: boolean
}
const PrimaryButton = ({text, loading, onClick, disabled, className}: PrimaryButtonProps & {className?: string}) => {
    return (
        <StyledPrimaryWithLoadingButton
          className={className}
          isLoading={!!loading}
          disabled={Boolean(disabled)}
          onClick={!loading ? onClick : () => {}}
        >
          <span>{text}</span>
          <ClipLoader loading={true} color={'white'} size={22} />
        </StyledPrimaryWithLoadingButton>
    )
};

type ButtonProps = { isLoading: boolean };
const StyledPrimaryWithLoadingButton = styled(StyledPrimaryButton)<ButtonProps>`
  position: initial;
  span {
    opacity: ${({isLoading}) => isLoading ? 0 : 1};
    transition: opacity 0.2s ease;
  }
  div {
    position: absolute;
    top: calc(50% - 12px);
    left: calc(50% - 15px);
    opacity: ${({isLoading}) => isLoading ? 1 : 0};
    transition: opacity 0.2s ease;
  }
`;

export default PrimaryButton;
